export default {
    feedTitle: 'MFC Share Feed',
}
